import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class TeacherPersonService {
	constructor(private httpclientService: HttpclientService) {}
	loadTeacherPersonList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/TeacherPersonGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InstructorPersonNotAllGetList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/InstructorPersonNotAllGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
